import { React, useState, useEffect } from "react";
import img_fondo_herramientas from "../../assets/images/img_fondo_herramientas.jpg";
import ico_handy from "../../assets/icons/ico_handy.svg";
import img_pajaro_tronco from "../../assets/images/img_pajaro_tronco.png";
import ico_huellas from "../../assets/icons/ico_huellas.svg";
import img_flores_tools from "../../assets/images/img_flores_tools.png";
import img_libelula_tools from "../../assets/images/img_libelula_tools.png";
import img_microorganismo from "../../assets/images/img_microorganismo.png";
import img_lagarto_verde from "../../assets/images/img_lagarto_verde.png";
import img_dron_tools from "../../assets/images/img_dron_tools.png";
import img_lady_bug from "../../assets/images/img_lady_bug.png";
import ico_info from "../../assets/icons/ico_info.png";
import GoToPage from "../../components/goToPage";
import SpeciesInfo from "../../components/speciesInfo";
const MonitoringToolsScreen = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
      console.log(width);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  return (
    <div className="w-full bg-[#002E0F]">
      <div className="w-full lg:h-[1080px] md:h-[520px] sm:h-[520px] h-[520px]  absolute z-10 ">
        <img
          loading="lazy"
          className="w-full h-full object-cover mix-blend-overlay "
          src={img_fondo_herramientas}
          alt="/"
        />
        {width < 770 ? (
          <div className="bg-gradient-to-t absolute w-full bottom-0 from-[#002E0F] h-[25rem]"></div>
        ) : null}
      </div>

      <div className="w-full mx-auto text-white relative z-10 ">
        <div className=" lg:pt-52 md:pt-46 sm:pt-28 pt-36 lg:mb-52 md:mb-5 sm:mb-10 mb-20 2xl:pb-40 lg:pb-40 md:pb-5 sm:pb-32 pb-32 w-full h-full flex lg:justify-start md:justify-start sm:justify-center justify-center  text-white ">
          <div className="lg:text-left md:text-left sm:text-center text-center xl:ml-72 lg:ml-20 md:ml-20 sm:ml-10 ml-10 mr-10   min-w-[10rem] max-h-32 ">
            <div className=" lg:pb-14 md:pb-5 sm:pb-5 pb-5">
              <GoToPage
                page="/"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-lg"
                fontSizeL="lg:text-base"
                fontSizeM="md:text-base"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-5"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
            </div>
            <div className="pb-10 flex lg:justify-start md:justify-start sm:justify-center justify-center ">
              <img
                loading="lazy"
                src={ico_handy}
                className=" lg:h-24 md:h-10 sm:h-20 h-20 "
              ></img>
            </div>
            <h1 className="2xl:text-7xl xl:text-5xl lg:text-5xl md:text-4xl sm:text-4xl text-3xl  font-bold mb-5">
              Herramientas sencillas <br /> para el monitoreo
            </h1>

            <p className="2xl:text-xl xl:text-lg lg:text-base md:text-xs sm:text-sm text-sm pb-5 ">
              Con toda la increíble diversidad de formas de vida existente, un
              primer paso en el monitoreo es decidir con cuál parte de dicha
              diversidad se trabajara. Lo más lógico es generar un inventario
              con los distintos grupos de especies que habitan en el área de
              operación de la empresa.
            </p>
            <p className="2xl:text-xl xl:text-lg lg:text-base md:text-xs sm:text-sm text-sm sm:text-xs">
              Este inventario debe realizarse a nivel de grupo o grupos
              taxonómicos y sirve como línea de referencia o base.
            </p>
          </div>
        </div>

        <div className="grid py-64 relative 2xl:px-72 xl:px-36 lg:px-20 md:px-20 sm:px-20 px-0 2xl:grid-cols-2 xl:grid-cols-2  lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 pb-20 min-w-[10rem]">
          <div className="grid grid-cols-1 lg:gap-0 md:gap-0 sm:gap-10 gap-10 h-fit lg:px-0 md:px-0 sm:px-10 px-10 lg:mb-0 md:mb-0 sm:mb-10 mb-10">
            <div className=" w-full h-full bg-[#048CC6] ">
              <div className="grid grid-cols-1 pt-20 lg:pl-40 md:pl-5 sm:pl-5 pl-5 px-20 gap-0">
                <div className="relative">
                  <img
                    loading="lazy"
                    src={ico_huellas}
                    className=" absolute "
                  ></img>
                </div>
                <div className="mt-[7rem] pr-10">
                  <h2 className="xl:text-2xl lg:text-lg md:text-lg sm:text-base text-base mb-5">
                    Aves
                  </h2>
                  <h1 className="xl:text-3xl lg:text-xl md:text-xl sm:text-text-xl text-xl  font-bold mb-5">
                    Observación desde <br /> punto fijo en 360 grados
                  </h1>
                  <GoToPage
                    page="/herramientas/observacion"
                    side="right"
                    name="Entrar"
                    fontSizeXL="xl:text-xl"
                    fontSizeL="lg:text-lg"
                    fontSizeM="md:text-lg"
                    fontSizeS="sm:text-lg"
                    fontSize="text-lg"
                    textType="font-bold"
                    textColor="text-white"
                    borderType="border-b-2"
                    borderColor="border-white"
                    iconSize="h-6"
                    iconColor="invert"
                    iconMargin="ml-5"
                  ></GoToPage>
                </div>
                <div className=" pt-10">
                  <h2 className="xl:text-2xl lg:text-lg md:text-lg sm:text-base text-base mb-5">
                    Anfibios y reptiles
                  </h2>
                  <h1 className="xl:text-3xl lg:text-xl md:text-xl sm:text-text-xl text-xl  font-bold mb-5">
                    Identificación visual <br /> en línea recta
                  </h1>
                  <GoToPage
                    page="/herramientas/identificacion-visual"
                    side="right"
                    name="Entrar"
                    fontSizeXL="xl:text-xl"
                    fontSizeL="lg:text-lg"
                    fontSizeM="md:text-lg"
                    fontSizeS="sm:text-lg"
                    fontSize="text-lg"
                    textType="font-bold"
                    textColor="text-white"
                    borderType="border-b-2"
                    borderColor="border-white"
                    iconSize="h-6"
                    iconColor="invert"
                    iconMargin="ml-5"
                  ></GoToPage>
                </div>
              </div>
              <div className="relative  lg:mt-[25rem] md:mt-[15rem] sm:mt-[15rem] mt-[15rem]">
                <img
                  src={img_pajaro_tronco}
                  className="absolute bottom-0 lg:w-[33rem] md:w-[20rem] sm:w-[20rem] w-[20rem] right-0 mt-20"
                ></img>
              </div>
            </div>
            <div className=" w-full h-full bg-[#F2B229]">
              <div className="grid  grid-row-1 h-full lg:pt-20 ">
                <div className=" h-full pb-40 lg:pl-40 md:pl-5 sm:pl-5 pl-5 px-20 ">
                  <div className="relative mb-36">
                    <img
                      loading="lazy"
                      src={ico_huellas}
                      className=" absolute mt-5"
                    ></img>
                  </div>
                  <div className=" relative z-20">
                    <h2 className="xl:text-2xl lg:text-lg md:text-lg sm:text-base text-base mb-5">
                      Árboles y plantas
                    </h2>
                    <h1 className="xl:text-3xl lg:text-xl md:text-xl sm:text-text-xl text-xl  font-bold mb-5">
                      Inventario <br /> de flora
                    </h1>
                    <GoToPage
                      page="/herramientas/inventario-flora"
                      side="right"
                      name="Entrar"
                      fontSizeXL="xl:text-xl"
                      fontSizeL="lg:text-lg"
                      fontSizeM="md:text-lg"
                      fontSizeS="sm:text-lg"
                      fontSize="text-lg"
                      textType="font-bold"
                      textColor="text-white"
                      borderType="border-b-2"
                      borderColor="border-white"
                      iconSize="h-6"
                      iconColor="invert"
                      iconMargin="ml-5"
                    ></GoToPage>
                  </div>
                </div>
                <div className="relative h-full ">
                  <img
                    src={img_flores_tools}
                    className="absolute right-0 bottom-0 lg:w-[20rem] md:w-[17rem] sm:w-[17rem] w-[15rem]"
                  ></img>
                </div>
              </div>
            </div>
            <div className=" w-full h-full bg-[#009269]">
              <div className="grid grid-cols-1 pt-20 lg:pl-40 md:pl-5 sm:pl-5 pl-5 lg:px-20 gap-0">
                <div className="relative">
                  <img
                    loading="lazy"
                    src={ico_huellas}
                    className=" absolute  "
                  ></img>
                </div>
                <div className="mt-[7rem]">
                  <h2 className="xl:text-2xl lg:text-lg md:text-lg sm:text-base text-base mb-5">
                    Anfibios y reptiles
                  </h2>
                  <h1 className="xl:text-3xl lg:text-xl md:text-xl sm:text-text-xl text-xl  font-bold mb-5">
                    Trampa de caída grande
                  </h1>
                  <GoToPage
                    page="/herramientas/trampa-caida-grande"
                    side="right"
                    name="Entrar"
                    fontSizeXL="xl:text-xl"
                    fontSizeL="lg:text-lg"
                    fontSizeM="md:text-lg"
                    fontSizeS="sm:text-lg"
                    fontSize="text-lg"
                    textType="font-bold"
                    textColor="text-white"
                    borderType="border-b-2"
                    borderColor="border-white"
                    iconSize="h-6"
                    iconColor="invert"
                    iconMargin="ml-5"
                  ></GoToPage>
                </div>
                <div className="pt-10">
                  <h2 className="xl:text-2xl lg:text-lg md:text-lg sm:text-base text-base mb-5">
                    Escarabajos estercoleros
                  </h2>
                  <h1 className="xl:text-3xl lg:text-xl md:text-xl sm:text-text-xl text-xl  font-bold mb-5">
                    Trampa de caída pequeña
                  </h1>
                  <GoToPage
                    page="/herramientas/trampa-caida-pequena"
                    side="right"
                    name="Entrar"
                    fontSizeXL="xl:text-xl"
                    fontSizeL="lg:text-lg"
                    fontSizeM="md:text-lg"
                    fontSizeS="sm:text-lg"
                    fontSize="text-lg"
                    textType="font-bold"
                    textColor="text-white"
                    borderType="border-b-2"
                    borderColor="border-white"
                    iconSize="h-6"
                    iconColor="invert"
                    iconMargin="ml-5"
                  ></GoToPage>
                </div>
              </div>
              <div className="relative bottom-0  lg:mt-[25rem] md:mt-[20rem] sm:mt-[20rem] mt-[20rem] bg-slate-500">
                <img
                  src={img_lagarto_verde}
                  className="absolute right-0 bottom-0 lg:w-[40rem] md:w-[25rem] sm:w-[25rem] w-[22rem]"
                ></img>
              </div>
            </div>
            <div className=" w-full h-full bg-[#F2B229] ">
              <div className="grid  grid-cols-1 pt-20 lg:pl-40 md:pl-5 sm:pl-5 pl-5 lg:px-40 gap-0">
                <div className="relative">
                  <img
                    loading="lazy"
                    src={ico_huellas}
                    className=" absolute  "
                  ></img>
                </div>
                <div className="mt-[7rem]">
                  <h2 className="xl:text-2xl lg:text-lg md:text-lg sm:text-base text-base mb-5">
                    Insectos
                  </h2>
                  <h1 className="xl:text-3xl lg:text-xl md:text-xl sm:text-text-xl text-xl  font-bold mb-5">
                    Trampas de luz
                  </h1>
                  <GoToPage
                    page="/herramientas/trampas-luz"
                    side="right"
                    name="Entrar"
                    fontSizeXL="xl:text-xl"
                    fontSizeL="lg:text-lg"
                    fontSizeM="md:text-lg"
                    fontSizeS="sm:text-lg"
                    fontSize="text-lg"
                    textType="font-bold"
                    textColor="text-white"
                    borderType="border-b-2"
                    borderColor="border-white"
                    iconSize="h-6"
                    iconColor="invert"
                    iconMargin="ml-5"
                  ></GoToPage>
                </div>
                <div className="pt-10">
                  <h2 className="xl:text-2xl lg:text-lg md:text-lg sm:text-base text-base mb-5">
                    Insectos
                  </h2>
                  <h1 className="xl:text-3xl lg:text-xl md:text-xl sm:text-text-xl text-xl  font-bold mb-5">
                    Métodos directos e <br /> indirectos de colecta <br /> para
                    insectos
                  </h1>
                  <GoToPage
                    page="/herramientas/metodos-colecta-insectos"
                    side="right"
                    name="Entrar"
                    fontSizeXL="xl:text-xl"
                    fontSizeL="lg:text-lg"
                    fontSizeM="md:text-lg"
                    fontSizeS="sm:text-lg"
                    fontSize="text-lg"
                    textType="font-bold"
                    textColor="text-white"
                    borderType="border-b-2"
                    borderColor="border-white"
                    iconSize="h-6"
                    iconColor="invert"
                    iconMargin="ml-5"
                  ></GoToPage>
                </div>
              </div>
              <div className="relative bottom-0  lg:mt-[25rem] md:mt-[15rem] sm:mt-[15rem] mt-[15rem] bg-slate-500">
                <img
                  src={img_lady_bug}
                  className="absolute left-0 bottom-0 mb-5 lg:w-[40rem] md:w-[27rem] sm:w-[27rem] w-[23rem]"
                ></img>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:gap-0 md:gap-0 sm:gap-10 gap-10 h-fit lg:px-0 md:px-0 sm:px-10 px-10">
            <div className=" w-full h-full bg-[#009269]">
              <div className="grid grid-cols-1 pt-20 lg:pl-40 md:pl-5 sm:pl-5 pl-5 lg:px-40 gap-0">
                <div className="relative">
                  <img
                    loading="lazy"
                    src={ico_huellas}
                    className=" absolute  "
                  ></img>
                </div>
                <div className="mt-[7rem]">
                  <h2 className="xl:text-2xl lg:text-lg md:text-lg sm:text-base text-base mb-5">
                    Aves y mamíferos
                  </h2>
                  <h1 className="xl:text-3xl lg:text-xl md:text-xl sm:text-text-xl text-xl  font-bold mb-5">
                    Cámaras trampa
                  </h1>
                  <GoToPage
                    page="/herramientas/camaras-trampa"
                    side="right"
                    name="Entrar"
                    fontSizeXL="xl:text-xl"
                    fontSizeL="lg:text-lg"
                    fontSizeM="md:text-lg"
                    fontSizeS="sm:text-lg"
                    fontSize="text-lg"
                    textType="font-bold"
                    textColor="text-white"
                    borderType="border-b-2"
                    borderColor="border-white"
                    iconSize="h-6"
                    iconColor="invert"
                    iconMargin="ml-5"
                  ></GoToPage>
                </div>
                <div className=" pt-10">
                  <h2 className="xl:text-2xl lg:text-lg md:text-lg sm:text-base text-base mb-5">
                    Macroinvertebrados
                  </h2>
                  <h1 className="xl:text-3xl lg:text-xl md:text-xl sm:text-text-xl text-xl  font-bold mb-5">
                    Monitoreo de <br /> aguas dulces
                  </h1>
                  <GoToPage
                    page="/herramientas/monitoreo-aguas"
                    side="right"
                    name="Entrar"
                    fontSizeXL="xl:text-xl"
                    fontSizeL="lg:text-lg"
                    fontSizeM="md:text-lg"
                    fontSizeS="sm:text-lg"
                    fontSize="text-lg"
                    textType="font-bold"
                    textColor="text-white"
                    borderType="border-b-2"
                    borderColor="border-white"
                    iconSize="h-6"
                    iconColor="invert"
                    iconMargin="ml-5"
                  ></GoToPage>
                </div>
                <div className=" pt-10">
                  <h2 className="xl:text-2xl lg:text-lg md:text-lg sm:text-base text-base mb-5">
                    Aves y murciélagos
                  </h2>
                  <h1 className="xl:text-3xl lg:text-xl md:text-xl sm:text-text-xl text-xl  font-bold mb-5">
                    Redes de niebla
                  </h1>
                  <GoToPage
                    page="/herramientas/redes-niebla"
                    side="right"
                    name="Entrar"
                    fontSizeXL="xl:text-xl"
                    fontSizeL="lg:text-lg"
                    fontSizeM="md:text-lg"
                    fontSizeS="sm:text-lg"
                    fontSize="text-lg"
                    textType="font-bold"
                    textColor="text-white"
                    borderType="border-b-2"
                    borderColor="border-white"
                    iconSize="h-6"
                    iconColor="invert"
                    iconMargin="ml-5"
                  ></GoToPage>
                </div>
              </div>
              <div className="relative bottom-0  lg:mt-[25rem] md:mt-[15rem] sm:mt-[15rem] mt-[15rem] bg-slate-500">
                <img
                  src={img_libelula_tools}
                  className="absolute bottom-0 lg:w-[20rem] md:w-[15rem] sm:w-[15rem] w-[15rem] lg:ml-60 md:ml-32 sm:ml-32 ml-32"
                ></img>
              </div>
            </div>
            <div className=" w-full h-full bg-[#82AB40]">
              <div className="grid  grid-cols-1 pt-20 lg:pl-40 md:pl-5 sm:pl-5 pl-5 lg:px-40 gap-0">
                <div className="relative">
                  <img
                    loading="lazy"
                    src={ico_huellas}
                    className=" absolute  "
                  ></img>
                </div>
                <div className="mt-[7rem] ">
                  <h2 className="xl:text-2xl lg:text-lg md:text-lg sm:text-base text-base mb-5">
                    Microorganismos <br /> y fauna del suelo
                  </h2>
                  <h1 className="xl:text-3xl lg:text-xl md:text-xl sm:text-text-xl text-xl  font-bold mb-5">
                    Análisis biológico <br /> de suelos
                  </h1>
                  <GoToPage
                    page="/herramientas/analisis-suelos"
                    side="right"
                    name="Entrar"
                    fontSizeXL="xl:text-xl"
                    fontSizeL="lg:text-lg"
                    fontSizeM="md:text-lg"
                    fontSizeS="sm:text-lg"
                    fontSize="text-lg"
                    textType="font-bold"
                    textColor="text-white"
                    borderType="border-b-2"
                    borderColor="border-white"
                    iconSize="h-6"
                    iconColor="invert"
                    iconMargin="ml-5"
                  ></GoToPage>
                </div>
              </div>
              <div className="relative bottom-0  lg:mt-[25rem] md:mt-[18rem] sm:mt-[18rem] mt-[18rem] bg-slate-500">
                <img
                  src={img_microorganismo}
                  className="absolute right-0 bottom-0 lg:w-[27rem] md:w-[20rem] sm:w-[20rem] w-[20rem] "
                ></img>
              </div>
            </div>
            <div className=" w-full h-full bg-[#048CC6]">
              <div className="grid  grid-cols-1 pt-20 lg:pl-40 md:pl-5 sm:pl-5 pl-5 lg:px-40 gap-0">
                <div className="relative">
                  <img
                    loading="lazy"
                    src={ico_huellas}
                    className=" absolute  "
                  ></img>
                </div>
                <div className="mt-[7rem]">
                  <h2 className="xl:text-2xl lg:text-lg md:text-lg sm:text-base text-base mb-5">
                    Todos los grupos
                  </h2>
                  <h1 className="xl:text-3xl lg:text-xl md:text-xl sm:text-text-xl text-xl  font-bold mb-5">
                    iNaturalist
                  </h1>
                  <GoToPage
                    page="/herramientas/iNaturalist"
                    side="right"
                    name="Entrar"
                    fontSizeXL="xl:text-xl"
                    fontSizeL="lg:text-lg"
                    fontSizeM="md:text-lg"
                    fontSizeS="sm:text-lg"
                    fontSize="text-lg"
                    textType="font-bold"
                    textColor="text-white"
                    borderType="border-b-2"
                    borderColor="border-white"
                    iconSize="h-6"
                    iconColor="invert"
                    iconMargin="ml-5"
                  ></GoToPage>
                </div>
                <div className="pt-10">
                  <h2 className="xl:text-2xl lg:text-lg md:text-lg sm:text-base text-base mb-5">
                    Ballenas
                  </h2>
                  <h1 className="xl:text-3xl lg:text-xl md:text-xl sm:text-text-xl text-xl  font-bold mb-5">
                    App de ballenas
                  </h1>
                  <GoToPage
                    page="/herramientas/app-ballenas"
                    side="right"
                    name="Entrar"
                    fontSizeXL="xl:text-xl"
                    fontSizeL="lg:text-lg"
                    fontSizeM="md:text-lg"
                    fontSizeS="sm:text-lg"
                    fontSize="text-lg"
                    textType="font-bold"
                    textColor="text-white"
                    borderType="border-b-2"
                    borderColor="border-white"
                    iconSize="h-6"
                    iconColor="invert"
                    iconMargin="ml-5"
                  ></GoToPage>
                </div>
                <div className="pt-10">
                  <h2 className="xl:text-2xl lg:text-lg md:text-lg sm:text-base text-base mb-5">
                    Aves, mamíferos, <br /> plantas y ecosistemas
                  </h2>
                  <h1 className="xl:text-3xl lg:text-xl md:text-xl sm:text-text-xl text-xl  font-bold mb-5">
                    Drones
                  </h1>
                  <GoToPage
                    page="/herramientas/drones"
                    side="right"
                    name="Entrar"
                    fontSizeXL="xl:text-xl"
                    fontSizeL="lg:text-lg"
                    fontSizeM="md:text-lg"
                    fontSizeS="sm:text-lg"
                    fontSize="text-lg"
                    textType="font-bold"
                    textColor="text-white"
                    borderType="border-b-2"
                    borderColor="border-white"
                    iconSize="h-6"
                    iconColor="invert"
                    iconMargin="ml-5"
                  ></GoToPage>
                </div>
              </div>
              <div className="relative bottom-0 lg:mt-[25rem] md:mt-[15rem] sm:mt-[15rem] mt-[15rem] bg-slate-500">
                <img
                  src={img_dron_tools}
                  className="absolute right-0 bottom-0 lg:w-[35rem] md:w-[24rem] sm:w-[24rem] w-[24rem] "
                ></img>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SpeciesInfo />
    </div>
  );
};

export default MonitoringToolsScreen;
